@if ((selectedConfiguratorType$ | async) === 'external_blind' && isJoinedTypesAndSystemsStep) {
  <icc-select-box
    [title]="'ROLLER_SHUTTER_LEGACY|Typ pancerza:' | translate"
    [description]="(profile$ | async)?.name"
    [imageUrl]="'/files/profile/' + ((profile$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeProfile()"
  ></icc-select-box>
}

@if (isJoinedTypesAndSystemsStep) {
  <icc-list
    [items]="systems"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectSystem($event)"
    [selected]="(selectedSystem$ | async).id"
    (showInfo)="showInfo($event)"
  ></icc-list>
}

@if (!isJoinedTypesAndSystemsStep) {
  <icc-list
    [items]="types"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectType($event)"
    [selected]="selectedType$ | async"
    (showInfo)="showInfo($event)"
  ></icc-list>
}
